import { cn } from "@/utils/classes";
import { getPageNumbers } from "@/utils/pagination";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { Button } from "@/components/ui/button";

/* Prop Types */
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  className?: string;
}

/*
 * Pagination component
 * This component is used to display pagination
 */
export const Pagination = ({ currentPage, totalPages, onPageChange, className }: PaginationProps) => {
  if (totalPages <= 1) return null;

  /* Render */
  return (
    <div className={cn("join flex justify-center gap-1", className)}>
      {/* Previous */}
      <Button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage <= 1} className="join-item">
        <ChevronLeftIcon className="size-4" />
      </Button>

      {/* Pages */}
      {getPageNumbers(currentPage, totalPages).map((pageNum, index) => {
        const isCurrentPage = pageNum === currentPage;
        const isDots = pageNum === "...";

        return (
          <Button
            key={index}
            onClick={() => (typeof pageNum === "number" ? onPageChange(pageNum) : undefined)}
            disabled={isDots}
            className={cn("join-item", {
              "btn-active": isCurrentPage,
              "btn-disabled cursor-default": isDots,
            })}
          >
            {pageNum}
          </Button>
        );
      })}

      {/* Next */}
      <Button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage >= totalPages} className="join-item">
        <ChevronRightIcon className="size-4" />
      </Button>
    </div>
  );
};
